import React from "react";

type ShakerLoaderProps = {
  size?: number;
  label?: string;
};

export default function ShakerLoader({
  size = 160,
  label = "Loading…",
}: ShakerLoaderProps) {
  const clipPathId = React.useId();

  return (
    <svg
      width={size}
      viewBox="0 0 680 340"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      aria-label="Loading"
    >
      <title>Loading</title>
      <defs>
        <clipPath id={clipPathId}>
          <rect x="308" y="178" width="64" height="108" rx="4" />
        </clipPath>
      </defs>

      <g>
        <animateTransform
          attributeName="transform"
          type="rotate"
          values="-18 340 210; 18 340 210; -14 340 210; 14 340 210; -18 340 210"
          dur="0.55s"
          repeatCount="indefinite"
        />
        <animateTransform
          attributeName="transform"
          additive="sum"
          type="translate"
          values="0 0; 4 -6; -2 0; 2 -4; 0 0"
          dur="0.55s"
          repeatCount="indefinite"
        />
        <rect
          x="316"
          y="128"
          width="48"
          height="18"
          rx="6"
          fill="currentColor"
          opacity="0.9"
        />
        <rect
          x="320"
          y="144"
          width="40"
          height="10"
          rx="3"
          fill="currentColor"
          opacity="0.6"
        />
        <rect
          x="308"
          y="154"
          width="64"
          height="112"
          rx="10"
          fill="currentColor"
          opacity="0.85"
        />
        <rect
          x="308"
          y="212"
          width="64"
          height="54"
          fill="#38bdf8"
          opacity="0.55"
          clipPath={`url(#${clipPathId})`}
        />
        <rect
          x="308"
          y="226"
          width="64"
          height="40"
          fill="#0ea5e9"
          opacity="0.45"
          clipPath={`url(#${clipPathId})`}
        />
        <rect
          x="316"
          y="158"
          width="8"
          height="96"
          rx="4"
          fill="white"
          opacity="0.18"
        />
        <polygon
          points="308,258 340,282 372,258"
          fill="currentColor"
          opacity="0.85"
        />
        <ellipse cx="340" cy="282" rx="10" ry="5" fill="currentColor" opacity="0.7" />
        <line
          x1="323"
          y1="132"
          x2="357"
          y2="132"
          stroke="white"
          strokeWidth="1.2"
          opacity="0.4"
        />
        <line
          x1="323"
          y1="136"
          x2="357"
          y2="136"
          stroke="white"
          strokeWidth="1.2"
          opacity="0.4"
        />
        <line
          x1="323"
          y1="140"
          x2="357"
          y2="140"
          stroke="white"
          strokeWidth="1.2"
          opacity="0.4"
        />
      </g>

      <circle cx="294" cy="158" r="4" fill="#38bdf8" opacity="0">
        <animate
          attributeName="opacity"
          values="0;1;0"
          keyTimes="0;0.2;1"
          dur="0.9s"
          begin="0.1s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="158;220"
          dur="0.9s"
          begin="0.1s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="386" cy="145" r="3" fill="#0ea5e9" opacity="0">
        <animate
          attributeName="opacity"
          values="0;1;0"
          keyTimes="0;0.3;1"
          dur="0.9s"
          begin="0.35s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="145;215"
          dur="0.9s"
          begin="0.35s"
          repeatCount="indefinite"
        />
      </circle>
      <circle cx="278" cy="152" r="3.5" fill="#7dd3fc" opacity="0">
        <animate
          attributeName="opacity"
          values="0;1;0"
          keyTimes="0;0.25;1"
          dur="0.9s"
          begin="0.6s"
          repeatCount="indefinite"
        />
        <animate
          attributeName="cy"
          values="152;225"
          dur="0.9s"
          begin="0.6s"
          repeatCount="indefinite"
        />
      </circle>

      {label && (
        <text
          x="340"
          y="318"
          textAnchor="middle"
          fontFamily="inherit"
          fontSize="13"
          fontWeight="500"
          fill="currentColor"
          opacity="0.6"
        >
          <animate
            attributeName="opacity"
            values="0.5;1;0.5"
            dur="1.1s"
            repeatCount="indefinite"
          />
          {label}
        </text>
      )}
    </svg>
  );
}
